
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/eventos",
      function () {
        return require("private-next-pages/eventos.tsx");
      }
    ]);
  